import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SetPositionRBAC = {
  pageID: '2278c7b31303b1b5422e925698521088',
  elementID: {
    View: '9e890ad982a644672db7e4616249a17b',
    BulkUpload: '46fb99d03fd5b4b5ad19d94c7a5b8317',
    SelectCategory: 'd853c25df1aa12069b92cb375b524948',
  },
} as const

export const useRBACSetPositionPage = createUseRBAC(SetPositionRBAC.elementID)

export type UseRBACSetPositionPageType = ReturnType<typeof useRBACSetPositionPage>
